// extracted by mini-css-extract-plugin
export default {"node":"TranslationNodeText_node__zN6a3"};